import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import http from './javascript/http'
import util from './javascript/util'
import mapUtil from './javascript/mapUtil'
// import JSEncrypt from 'jsencrypt'
import Vant from 'vant'; //引入vant


import './javascript/rem'
import 'vant/lib/index.css' //引入vant的样式
import './style/index.less'

import './style/reset.css'
import './style/animate.min.css'
import 'swiper/dist/css/swiper.css'
import 'vux/src/styles/1px.less'

//富文本编辑器
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor)

//工具函数
import * as tools from '@/javascript/tools'
Vue.prototype.$tools = tools

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import 'video.js/dist/video-js.css';
import 'videojs-contrib-hls'
import VideoPlayer from 'vue-video-player'


Vue.use(VideoPlayer);
Vue.use(Vant); 

Vue.use(ElementUI)

//RSA加密方法
Vue.prototype.$getRsaCode = function(pubKey, str) { //注册方法
  let encryptStr = new JSEncrypt();
  encryptStr.setPublicKey(pubKey); //设置 加密公钥
  let data = encryptStr.encrypt(str.toString()); //进行加密
  return data;
}

Vue.config.productionTip = false

// 解决vue切换路由控制台报错，Uncaught (in promise)
import Router from 'vue-router'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

/**
 * 知识库索引分类
 * @type {string}
 */
export const INDEX_NAME_TYPE = {
    wtcpBic: 'wtcp-bic',
    driveCamp: 'wtcp-bic-drive-camp', //自驾游营地
    scenic: 'wtcp-bic-scenic', //景区、旅游示范村
    village: 'wtcp-bic-scenic-new',   //景区最美乡村
    rural: 'wtcp-bic-rural', //农家乐
    periphery: 'wtcp-bic-periphery', //周边（包括：特色小吃（美食）、餐饮、小吃街、购物场所、特产）
    travelAgent: 'wtcp-bic-travel-agent', //旅行社
    car: 'wtcp-bic-car', //租车
    newsList: 'wtcp-cms-news', //新闻列表
    strList: 'wtcp-tips', //攻略
    travelList: 'wtcp-note', //游记
    hotelList: 'wtcp-bic-hotel', //酒店
    traService: 'wtcp-bic-poi', //出行
    heritage: 'wtcp-bic-heritage', //文化遗产
    venue: 'wtcp-bic-venue', //场馆信息
    poi: 'wtcp-bic-poi', //poi
    caterList: 'wtcp-bic-catering', //餐饮住宿（餐饮管理）
    // 电商
    ticket: 'wtcp-ecrm-commodity-ticket', //电商-门票
    ecrmHotel: 'wtcp-ecrm-commodity-hotel', //电商-酒店
    ecrmCatering: 'wtcp-ecrm-food', //电商-餐厅
    ecrmRoute: 'wtcp-ecrm-commodity-route', //电商-线路
    produce: 'wtcp-ecrm-product',
    promotions: 'wtcp-promotions'
    
}


Vue.prototype.INDEX_NAME_TYPE = INDEX_NAME_TYPE

/**
 * 信息采集分类编码
 * @type {string}
 */
export const XXCJ_TYPE_CODE = {
    // 景区
    JQ: '125001001', // 普通景区
    LYSFC: '125001002', // 旅游示范村
    ZMXC: '125001003',  //最美乡村
    // 周边管理
    WC: '125002008', // 文创
    XC: '125002001', // 特色小吃
    CY: '125002002', // 餐饮服务
    ZCT: '125002002001', // 餐饮服务-中餐厅
    CC: '125002002002', // 餐饮服务-川菜
    ZHJL: '125002002003', // 餐饮服务-综合酒楼
    GDCYC: '125002002004', // 餐饮服务-广东菜（粤菜）
    XCJ: '125002003', // 小吃街
    GW: '125002004', // 购物场所
    TC: '125002005', // 特产
    YL: '125002006', // 娱乐
    KTV: '125002006001', // 娱乐-KTV
    JB: '125002006002', // 娱乐-酒吧
    MS: '125002007', // 美食
    // 从业
    LXS: '125003001', // 旅行社
    // 出行
    ZC: '125004001', // 租车
    JTSN: '125004002', // 交通枢纽
    HCZ: '125004002001', // 交通枢纽-火车站
    QCZ: '125004002002', // 交通枢纽-汽车站
    FJC: '125004002003', // 交通枢纽-飞机场
    DTZ: '125004002004', // 交通枢纽-地铁站
    CB: '125004002005', // 交通枢纽-船舶
    // 休闲娱乐
    ZJYD: '125005001', // 自驾营地
    NJL: '125005002', // 农家乐
    // 文化场馆(均有下级分类)
    TSLB: '125006002', // 厅室
    CGLX: '125006001', // 场馆
    ZP: '125006003', // 展品
    // 文化遗产(均有下级分类)
    FYLX: '125007001', // 非遗
    MR: '125007002', // 名人
    // 餐饮住宿
    JD: '125008001', //酒店(有下级分类)   
    ZTJD: '125008001002', // 酒店-主题酒店
    JDMS: '125008001010', // 酒店-民宿

}

Vue.prototype.XXCJ_TYPE_CODE = XXCJ_TYPE_CODE

/**
 * POI类型编码
 * @type {string}
 */
Vue.prototype.POI_TYPE = {
    scenicSpot: '127001', // 景点
    theToilet: '127002', // 厕所
    park: '127003', // 停车场
    visitorCenter: '127004', // 游客中心
    alleyway: '127005', // 出入口
    shop: '127006', // 购物
    food: '127007', // 美食
    garage: '127008', // 修理厂
    gas: '127009', // 加油站
    pharmacy: '127010', // 医疗药店
    fitness: '127011', // 文体健身
    security: '127012', // 治安/消防
    ATM: '127013', // 银行/ATM
    // 127017: 充电桩
    // 127021: 商业圈
    // 127019 :超市
    // 127018: 24H便利店
    // 127022: 书店
    // 127020: 医院
}

// 收藏信息、历史记录所属的服务类型
export const SERVICE_TYPE = {
    GL: '100', // 攻略目录页
    YJ: '200', // 游记详情页
    MDD: '300', //目的地详情
    JQ: '400', // 景区详情页
    LXS: '500', //旅行社详情
    NJL: '600', // 农家乐详情
    ZC: '700', // 租车详情
    ZJ: '800', // 自驾营地详情
    LY: '900', // 旅游示范村详情
    CY: '1000', //餐饮详情
    JD: '1100', //酒店详情
    XL: '1200', //线路详情
    XW: '1300', //新闻详情
    YYYC: '1400', //演艺演出详情
    CYTC: '1500', //餐饮套餐详情
    WCCP: '1600', //文创产品详情
}
Vue.prototype.SERVICE_TYPE = SERVICE_TYPE

Vue.config.ignoredElements = ['wx-open-launch-weapp']

Vue.prototype.co_ver = {
    cover: false
}

// 按需导入项目mian文件
// import './main/jts-main.js'  // 金台山
// import './main/lhl-main.js' // 罗汉林 
// import './main/hznz-main.js' // 汉中南郑 
// import './main/sx-tc-main.js' // 陕西铜川 
// import './main/qh-sjy-main.js' // 青海三江源
// import './main/nz-yjzf-main.js' // 南郑--应急执法
// import './main/tc-yjzf-main.js' // 铜川--应急执法
import './main/lyx-main.js' // 海晏
// import './main/xj-jh-main.js' // 新疆精河
// import './main/qc-zzl-main.js' // 庆城周祖陵
// import './main/gs-sbc-main.js' // 甘肃-石包城
// import './main/qh-glz-main.js' // 青海-果洛州
// import './main/qh-ys-mian.js' // 青海-玉树


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')




